export default [
    {
        name: 'Contratações',
        url: '/credenciados/apoios/contratacoes',
        icon: 'fa fa-book',
        badge: {
            variant: 'primary',
            text: 'APOIO'
        },
        regras: 'CRED-APOIO-CONT-00'
    }
]
